// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_blocks_header-nav_js") return "./js/chunks/fb661435e99f24ac4a5f.js";
	if (chunkId === "assets_js_modules_breakpoint_js") return "./js/chunks/112b20e82e96c43950a6.js";
	if (chunkId === "assets_js_modules_marquee_js") return "./js/chunks/f86b20098cf5cdc042bf.js";
	if (chunkId === "assets_js_modules_scrollerHorizontal_js") return "./js/chunks/c5b911d4ac6e49d99578.js";
	if (chunkId === "assets_js_pages_abecedaire_js") return "./js/chunks/0afead420f024b82addd.js";
	if (chunkId === "assets_js_strates_chiffres_cles_js") return "./js/chunks/76dbd5af053bd77e1f19.js";
	// return url for filenames based on template
	return undefined;
};